import React, {Component} from "react"
import {Link} from "react-router-dom"

import {handleDestroyError} from "."
import {Area} from "~/utils/ShelfEntities"
import Button from "~/components/Button"
import {withTranslation} from "react-i18next"

const icon = require("~/icons/area_32_blue.svg")
const icon_delete = require("~/icons/action_delete.svg")
const icon_edit = require("~/icons/action_edit.svg")

class ListItemArea extends Component {
  destroyArea() {
    if (window.confirm(this.props.t("zones.deleteConfirmation"))) {
      Area.destroy(this.props.id)
        .then(() => this.props.update())
        .catch(handleDestroyError)
    }
  }

  render() {
    return (
      <div className="sh-list-item">
        <img src={icon} alt={"Area"} />
        <div className={"content"}>
          <Link to={`/area/${this.props.id}`}>
            <div className="primary">{this.props.name}</div>
          </Link>
        </div>

        {!this.props.disableActions && (
          <div className="actions">
            <Button
              onClick={this.destroyArea.bind(this)}
              icon={icon_delete}
              label={this.props.t("delete")}
            />
            <Button
              to={"/areas/" + this.props.id}
              icon={icon_edit}
              label={this.props.t("edit")}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(ListItemArea)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemArea.js